import { useEffect, useRef } from "react";
import Bold from "./Bold"
import Component, { PageEl } from '@/frontend/components/qecomps/Component'
import Img from "./Img";
export default p => Component(p, Page);
const Page: PageEl = (props: {} & { [key: string]: any }, refresh, getProps, onLoad, onConnected, dies, isFront, z) => {
  let ref = useRef(null)
  useEffect(() => {
    if (window.innerWidth > 760) {
      props.maxwidth = "calc(min(27rem, 48vw))"
    }
    else {
      props.maxwidth = "100vw"
    }
    refresh()

    setTimeout(() => {
      props.elementHeight = ref.current.offsetHeight;
      props.lineHeight = parseFloat(getComputedStyle(ref.current).lineHeight);
      props.lines = Math.round(props.elementHeight / props.lineHeight);
      refresh()
    }, 1000);
  }, [])
  return <f-c className="hover:bg-[#CADDBE74] transition duration-300 ease-in-out cursor-pointer"
    style={{ maxHeight: 150, minHeight: 80, maxWidth: props.maxwidth, minWidth: props.maxwidth, borderRadius: 5 }} onClick={() => { props.on?.() }}>
    <sp-3 />
    <img src={props.icon} alt={props.alt} style={{ height: 80, minHeight: 80, minWidth: 106, maxWidth: 106, borderRadius: 5 }}
      loading="lazy"
    />
    <sp-3 />
    <c-xse style={{ maxHeight: 80, minHeight: 80, marginLeft: 4, marginRight: 2 }}>
      <f-13 ref={ref} style={{ fontFamily: z.lang.ffb || z.lang.ffb, fontWeight: !z.lang.ffb ? 600 : "normal" }}>{props.title1}</f-13>
      {props.lines < 2 ? <f-11>{props.title2}</f-11> : null}
      <f-c>{props.lines > 1 ? <><f-11>{props.title2}</f-11>
        <sp-2 /> </> : null}
        <f-11>{props.title3}</f-11>
      </f-c>
    </c-xse>
    <sp-3 />
  </f-c>
}

